'use client';
import { useEffect } from 'react';
import { CriteoTracker } from '@weberus/client-tracker';

export function CriteoTrackerInitializer() {
  useEffect(() => {
    CriteoTracker.initialize();
  }, []);

  return null;
}
